import axios from "axios";

const URL = process.env.REACT_APP_API_BASE_PROD_URL || process.env.REACT_APP_API_BASE_URL || 'http://localhost:3002'; // Fallback to localhost if not set
// User API functions    

export async function getPracticeByMDBId(id) {
  // send the id in the JSON body
  const response = await axios.post(
    `${URL}/practiceMDBId`,
    { id },
    { headers: { "Content-Type": "application/json" } }
  );

  if (response.status === 200) {
    return response.data;
  }
}

export async function getPracticeByNumberPublic(practiceNumbers) {
  try {
    const response = await axios.post(`${URL}/practice/publicnames`, {
      practiceNumbers,
    });

    if (response.status === 200) {
      return response.data; // ✅ Return the fetched practices
    } else {
      return []; // ✅ Return empty array if request fails
    }
  } catch (error) {
    console.error("Error fetching practices:", error);
    throw new Error(
      error.response?.data?.message || "Failed to fetch practices"
    );
  }
}

export async function getPracticeLocations(practiceNumbers) {
  try {
    const response = await axios.post(`${URL}/practice/locations`, {
      practiceNumbers,
    });
    if (response.status === 200) {
      return response.data;  // [ { practiceNumber, lat, lng }, … ]
    }
    return [];
  } catch (error) {
    console.error("Error fetching practice locations:", error);
    return [];
  }
}